// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import DirtyFormController from "./dirty_form_controller"
application.register("dirty-form", DirtyFormController)

import MetricaController from "./metrica_controller"
application.register("metrica", MetricaController)

import FaviconController from "./favicon_controller"
application.register("favicon", FaviconController)

import IntervalModeController from "./interval_mode_controller"
application.register("interval-mode", IntervalModeController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
